export const SET_LOGGED_USER_PROFILE = 'SET_LOGGED_USER_PROFILE';
export const GET_LOGGED_USER_PROFILE = 'GET_LOGGED_USER_PROFILE';



// WEBPACK FOOTER //
// ./src/actions/userTypes.js